import { connect } from 'react-redux';
import { submit, getFormValues } from 'redux-form';
import { getPortfolioEditForm, fetchUserEntries, saveFormRevisionObject, clearFormRevisionObject,
  changeEditFormStep, toggleEditForm } from 'profile/ducks/portfolio_form';
import { createPortfolioByRevision, createPortfolioByUpload, updatePortfolioEntry,
 fetchAllPortfolioEntries } from 'profile/ducks/portfolio';
import { setBannerError } from 'error';
import PortfolioForm from 'profile/components/portfolio/portfolio_form';
import partial from 'lodash/partial';
import { PORTFOLIO_FORM } from 'profile/constants';

function mapStateToProps(state) {
  const formData = getPortfolioEditForm(state);

  return {
    user: state.user,
    categories: state.categories.data,
    currentStep: formData.currentStep,
    formOpen: formData.formOpen,
    formData,
    formValues: getFormValues(PORTFOLIO_FORM)(state),
  };
}

export default connect(mapStateToProps, {
  fetchUserEntries,
  createPortfolioByRevision,
  createPortfolioByUpload,
  updatePortfolioEntry,
  saveFormRevisionObject,
  clearFormRevisionObject,
  setBannerError,
  saveEntryForm: partial(submit, PORTFOLIO_FORM),
  toggleForm: toggleEditForm,
  changeStep: changeEditFormStep,
  fetchAllPortfolioEntries
})(PortfolioForm);



// WEBPACK FOOTER //
// ./profile/containers/portfolio/portfolio_form.jsx